import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { SplitModalContext } from './split-modal';
import { ModalFooterButtons } from './modal-footer-buttons';
const FOOTER_BUTTONS_STYLES = {
    fullModal: {
        gridColumn: 2,
        justifyContent: 'flex-end',
    },
    contextual: {},
};
/**
 * Button container with automatic positioning. In FullModal variant, buttons align right
 * and coordinate with optional description text. Must be used inside SplitModalFooter.
 *
 * @param children - Modal button components
 * @example
 * ```tsx
 * <SplitModalFooterButtons>
 *   <ModalSecondaryButton text="Cancel" />
 *   <ModalPrimaryButton text="Save" />
 * </SplitModalFooterButtons>
 * ```
 */
export const SplitModalFooterButtons = ({ children, ...props }) => {
    const context = React.use(SplitModalContext);
    if (!(context === null || context === void 0 ? void 0 : context.variant)) {
        return null;
    }
    const buttonsStyle = FOOTER_BUTTONS_STYLES[context.variant] || {};
    return (_jsx(ModalFooterButtons, { ...props, ...buttonsStyle, children: children }));
};
